<div class="container">
  <div class="row">
    <div class="col-md-12">
      <mat-card appearance="outlined" class="error-head text-center mt-3">
        <mat-card-title class="mat-headline-2">
          {{
            'NOTIFICATIONS.ERROR.loading.app.title'
              | translate : { title: APP_TITLE }
          }}
        </mat-card-title>

        <mat-card-subtitle class="mat-header-content mt-3">
          {{
            'NOTIFICATIONS.ERROR.loading.app.body'
              | translate : { title: APP_TITLE }
          }}
        </mat-card-subtitle>
        <startup-errors *ngIf="_startupService.errors"></startup-errors>
      </mat-card>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <mat-card
        appearance="outlined"
        *ngFor="let currentError of errors"
        class="error-card mt-auto"
      >
        <mat-card-title *ngIf="currentError.TITLE !== ''">
          {{ currentError.TITLE }}
        </mat-card-title>
        <mat-card-content
          class="error-card-content"
          *ngIf="currentError.BODY !== ''"
        >
          {{ currentError.BODY }}
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
